module.exports = __webpack_public_path__ + "img/excel-icon-accent.bbb45cbe.svg";